import React from 'react';

import requireAuth from '~components/hocs/requireAuth';
import AdminTemplate from '../layout/AdminTemplate';
import { DiagnosticsReportView, hasAiInsightsAccess } from '../features/ai-insights';

const META_TAGS = {
  title: 'AI Insights - Prerender.io',
};

function DiagnosticsReportPage() {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <DiagnosticsReportView />
    </AdminTemplate>
  );
}

export default requireAuth(DiagnosticsReportPage, hasAiInsightsAccess);
